import { sh } from '@tpluscode/rdf-ns-builders';
import { isNamedNode } from 'is-graph-pointer';
export class TargetNode {
    constructor(nodes) {
        this.nodes = nodes;
    }
    buildPatterns({ focusNode: { value } }) {
        const targetNodes = this.nodes
            .filter(isNamedNode)
            .map(({ term }) => ({ ['?' + value]: term }));
        return {
            constructClause: [],
            whereClause: [{
                    type: 'values',
                    values: targetNodes,
                }],
        };
    }
}
TargetNode.property = sh.targetNode;
